import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

axios.defaults.headers.post['Content-Type'] = 'application/json';

// Acción para obtener los datos del entorno de un nodo
export const teslaNodo = createAsyncThunk(
    'teslaNodo/getTeslaNodo',
    async ({ lat, lon }) => {
        try {
            const response = await axios.get("/api/sensor/getTeslaNodo", {
                params: {
                    lat,
                    lon
                }
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    }
);